import type { FC } from 'react';
import React from 'react';

import type { PageQuery } from '@graphql/platform';

import { Reviews } from '@root/components/landing_pages/smart_storage_v2/reviews';

import { PageContent } from './shared';

export const PageReviews: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  const title = page.reviewsTitle.trim().replace(/^(\S+)\s/, '$1\n');

  return (
    <PageContent>
      <Reviews title={title} reviews={page.reviews} />
    </PageContent>
  );
};
